import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ThankYouSlipLayer from "../components/ThankYouSlipLayer";

const ThankYouSlipPage = () => {
    return (
        <MasterLayout>
            <ThankYouSlipLayer />
        </MasterLayout>
    );
};

export default ThankYouSlipPage;
